import React from "react";
import styled from "styled-components";
import LotusLogo from '../../Assets/Logo Lotus.png';


const StyleTop = styled.div`
    direction: ltr;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100% ;
    position: relative;
    align-items: center;
    padding: 1rem 0;
    .logo{
        width: 20%;
        position: relative;
    }
    @media screen and (max-width:850px) {
        padding: 0;
        width: 100%;
        .logo{
            width: 30%;
        }
        
    }

`

const TopLotus =()=>{
    return(
        <StyleTop> 
            {/* <img src={LotusLogo} alt='' className="logo"/> */}
        </StyleTop>
    )
}
export default TopLotus